import React from 'react';

const FormField = ({
  label,
  id,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = '',
  helpText,
  ...props
}) => {
  const fieldId = id || name;
  const hasError = !!error;

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label
          htmlFor={fieldId}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <input
        id={fieldId}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`input-field transition-all duration-200 ${hasError ? 'border-red-500 focus:border-red-500 focus:ring-red-500/30' : 'border-slate-200 focus:border-primary-500 focus:ring-primary-500/30'} ${disabled ? 'bg-slate-50 cursor-not-allowed text-slate-400' : 'bg-white'}`}
        {...props}
      />

      {helpText && !error && (
        <p className="text-sm text-gray-500">{helpText}</p>
      )}

      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default FormField;